// components/Mobile/MobileMenu.jsx
/* eslint-disable react/prop-types */
/* eslint-disable arrow-body-style */
import React, { memo } from 'react';
import { useLanguage } from '@components/common/locale/useLanguage';
import { useNav } from '@components/common/context/NavContext';
import MenuNavigationMobile from '../MenuNavigationMobile';
import RandomizedProductPicksMobile from '../RandomizedProductPicksMobile';
import ProductCardMobileMemoized from './ProductCardMobileMemoized';
import { processProducts, extractDescriptionText, createCategoryId } from '../utils/categoryHelpers';
var MobileMenu = /*#__PURE__*/memo(_ref => {
  var {
    categories,
    collections,
    storeStatus,
    selectedCategory,
    handleCategorySelect,
    navRef,
    setCategoryRef
  } = _ref;
  var {
    isAr
  } = useLanguage();
  var {
    headerVisible,
    headerHeight
  } = useNav();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RandomizedProductPicksMobile, {
    storeStatus: storeStatus,
    collections: collections
  }), /*#__PURE__*/React.createElement("div", {
    ref: navRef,
    className: "sticky-nav",
    style: {
      position: 'sticky',
      top: headerVisible ? "".concat(headerHeight, "px") : 0,
      zIndex: 91,
      backgroundColor: '#fff',
      width: '100%',
      transition: 'top 0.3s ease-in-out, background-color 0.3s ease'
    }
  }, /*#__PURE__*/React.createElement(MenuNavigationMobile, {
    onCategorySelect: handleCategorySelect,
    categories: categories,
    activeCategory: selectedCategory
  })), /*#__PURE__*/React.createElement("div", {
    className: " py-6 pr-0"
  }, categories.map(category => {
    var filteredProducts = processProducts(category);
    if (filteredProducts.length === 0) return null;
    var categoryId = createCategoryId(category.name, 'mobile-category');
    return /*#__PURE__*/React.createElement("div", {
      key: category.name,
      className: "mb-12",
      id: categoryId,
      ref: _ref2 => setCategoryRef(category.name, _ref2)
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center gap-4 mb-8 max-w-[40rem] ml-auto"
    }, /*#__PURE__*/React.createElement("div", {
      className: "h-[0.8rem] bg-primary w-[2.1rem] flex-shrink-0"
    }), /*#__PURE__*/React.createElement("h3", {
      className: "text-[#0E0F0B] font-[500] font-zoom-pro-compact uppercase text-[1.6rem] whitespace-nowrap"
    }, isAr ? category.nameAr || category.name : category.name), /*#__PURE__*/React.createElement("div", {
      className: "h-[0.8rem] bg-primary flex-grow"
    })), /*#__PURE__*/React.createElement("div", {
      className: "grid grid-cols-2 gap-x-[1.9rem] gap-y-[5rem] mt-[6rem] px-4"
    }, filteredProducts.map(product => {
      var _product$price, _product$customizatio;
      var priceText = ((_product$price = product.price) === null || _product$price === void 0 || (_product$price = _product$price.regular) === null || _product$price === void 0 ? void 0 : _product$price.value) || '';
      var imageUrl = product.image || '';
      var descriptionText = extractDescriptionText(isAr ? product.descriptionAr || product.description : product.description);
      var isCustomizable = !!((_product$customizatio = product.customizationGroups) !== null && _product$customizatio !== void 0 && _product$customizatio.length);
      return /*#__PURE__*/React.createElement(ProductCardMobileMemoized, {
        storeStatus: storeStatus,
        key: product.ProductId,
        image: imageUrl,
        isNewItem: product === null || product === void 0 ? void 0 : product.new_item,
        category: isAr ? category.nameAr || category.name : category.name,
        name: isAr ? product.nameAr || product.name : product.name,
        description: descriptionText,
        price: priceText,
        isSpicy: product.isSpicy,
        url: product.url,
        productId: product.productId,
        isCustomizable: isCustomizable
      });
    })));
  })));
});
MobileMenu.displayName = 'MobileMenu';
export default MobileMenu;